import H3 from '@base/H3/H3';
import H5 from '@base/H5/H5';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import RadioButton from '@base/RadioButton/RadioButton';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { DoubtImageWrapper } from '../DoubtCard';

const StyRadio = styled(RadioButton)`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.LARGE};
`;

const SampleDoubtsWrapper = styled.div`
  width: 272px;
  height: 208px;
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: ${boxShadowGenerator()};
  padding: ${Spacings.SPACING_4B};
  background-color: var(--color-base-1);
  grid-column: span 6;
  margin-top: ${Spacings.SPACING_8B};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;

const StyH3 = styled(H3)`
  grid-column: span 10;
  margin-top: ${Spacings.SPACING_11B};
`;

const Label = ({ index }) => {
  return <H5>Sample doubt {index + 1}</H5>;
};

const renderSampleDoubts = (
  samples = {},
  selectedSampleSolution,
  onChangeSampleSolution
) => {
  const rendDoubt = samples?.map((sample, index) => {
    const isSelected = selectedSampleSolution?.doubt_uid === sample.doubt_uid;
    return (
      <SampleDoubtsWrapper
        key={sample.doubt_uid}
        onClick={() => onChangeSampleSolution(sample.doubt_uid)}
      >
        <StyRadio
          checked={isSelected}
          label={<Label index={index} />}
          key={sample.doubt_uid}
        />
        <DoubtImageWrapper content={sample.image} />
      </SampleDoubtsWrapper>
    );
  });
  return <>{rendDoubt}</>;
};

const SelectDoubt = ({
  selectedSampleSolution,
  onChangeSampleSolution,
  samples
}) => {
  return (
    <>
      <StyH3>Pick a sample doubt</StyH3>
      {renderSampleDoubts(
        samples,
        selectedSampleSolution,
        onChangeSampleSolution
      )}
    </>
  );
};

export default SelectDoubt;
